<template>
  <!-- D: 주문현황(주문내역:주문서) -->
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">주문현황</h1>
      <BreadCrumb :breadcrumbs="getBreadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 주문현황(주문내역:주문서) 페이지 -->
      <div class="p-order-history-wrap">
        <!-- D: 상단 탭 : 주문내역, 출고현황, 매입현황 -->
        <div class="c-tabs">
          <ul>
            <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
            <li class="tab-item">
              <a
                href="javascript:void(0);"
                @click="btnCmd('tab1Click', { tab1Index: 0 })"
                :class="[
                  'tab-anchor',
                  {
                    'is-active': data.tab1Index === 0,
                  },
                ]"
                role="tab"
                aria-selected
              >
                주문내역
              </a>
            </li>
            <li class="tab-item">
              <a
                href="javascript:void(0);"
                @click="btnCmd('tab1Click', { tab1Index: 1 })"
                :class="[
                  'tab-anchor',
                  {
                    'is-active': data.tab1Index === 1,
                  },
                ]"
                role="tab"
              >
                출고현황
              </a>
            </li>
            <li class="tab-item">
              <a
                href="javascript:void(0);"
                @click="btnCmd('tab1Click', { tab1Index: 2 })"
                :class="[
                  'tab-anchor',
                  {
                    'is-active': data.tab1Index === 2,
                  },
                ]"
                role="tab"
              >
                매입현황
              </a>
            </li>
          </ul>
        </div>
        <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
        <div class="c-tab-panel-wrap">
          <!-- tab content: tab1 -->
          <div
            class="tab-panel"
            role="tabpanel"
            aria-labelledby="tab4-1"
            :hidden="data.tab1Index != 0"
          ></div>
          <!-- tab content: tab2 -->
          <div
            class="tab-panel"
            role="tabpanel"
            aria-labelledby="tab4-2"
            :hidden="data.tab1Index != 1"
          ></div>
          <!-- tab content: tab3 -->
          <div
            class="tab-panel"
            role="tabpanel"
            aria-labelledby="tab4-3"
            :hidden="data.tab1Index != 2"
          >
            <PurchaseListTab />
          </div>
        </div>
        <!-- // D: 상단 탭 : 주문내역, 출고현황, 매입현황 -->

        <!-- D: 주문내역 조회&목록 -->
        <PurchaseListCont />
      </div>
    </div>

    <QuickMenu />
  </div>

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <CancelFieldPop v-if="data.popup.isModalVisible" />
</template>
<script setup name="purchaseList">
import { onMounted, reactive, watch, computed } from "vue";

import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import PurchaseListTab from "@/components/paintpro/order/purchaseListTab.vue";
import PurchaseListCont from "@/components/paintpro/order/purchaseListCont.vue";
import CancelFieldPop from "@/components/paintpro/order/cancelFieldPop.vue";

import { useRoute, useRouter } from "vue-router";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

const router = useRouter();

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    basketCount: 0,
    userLoginInfo: {},
    breadcrumbItems: [],
    query: {},
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {
    isModalVisible: false,
    isModalVisible2: false,
    isCurrentInquery: true,
  },
  tab1Index: 0,
});

watch(
  () => store.useBasketCountStore().basketCount,
  (newValue) => {
    data.page.basketCount = newValue;
  }
);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  data.page.query = useRoute().query || {};
  data.tab1Index = 2;
  await pageInitData();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: purchaseList.pageInitData] `);
    return false;
  }
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
}

const getBreadcrumbItems = computed(() => {
  let list = [
    { name: "주문현황", path: "/paintpro/orderList" },
    { name: "매입현황", path: "" },
  ];
  return list;
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "tab1Click") {
    data.tab1Index = parms.tab1Index;
    if (parms.tab1Index === 0) {
      router.push({
        path: "/paintpro/orderList",
      });
    } else if (parms.tab1Index === 1) {
      router.push({
        path: "/paintpro/orderList/shipmentList",
      });
    } else if (parms.tab1Index === 2) {
      router.push({
        path: "/paintpro/orderList/purchaseList",
      });
    }
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
</script>
<style scoped></style>
